import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import {FormArray, FormGroup} from "@angular/forms";
import {
  JaarrapportageEntity,
  ClientEntity,
  TrialBalanceItem, Jaarrekening, Jaarrapportage, BokkzJrLogic
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { combineLatest, distinctUntilChanged, Observable, ReplaySubject, Subject, takeUntil } from "rxjs";
import { SpecFormattedexplanationComponent } from '../spec-formattedexplanation/spec-formattedexplanation.component';
import { SpecTrialbalanceComponent } from '../spec-trialbalance/spec-trialbalance.component';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-waardeveranderingen-iva-mva',
  templateUrl: './spec-waardeveranderingen-iva-mva.component.html',
  imports: [
    SpecFormattedexplanationComponent,
    SpecTrialbalanceComponent,
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiDetailsModule,
    CommonModule
  ],
  styleUrls: ['./spec-waardeveranderingen-iva-mva.component.scss']
})
export class SpecWaardeveranderingenIvaMvaComponent implements OnInit,OnChanges,OnDestroy {

  @Input() public id!: string;
  @Input() selectedTabObservable!: Observable<number>;
  private selectedTabSubject = new ReplaySubject<number>(1);
  showCustomControls = true;
  private destroy$ = new Subject<void>();
  public selectedTab = 0;
  public index = 0;
  public dialogVisible = false;
  public client = {} as ClientEntity;
  public jrEntity = {} as JaarrapportageEntity;
  public isRechtspersoon = false;

  public changesInValueIntangibleAssetsPropertyPlantEquipmentFg = {} as FormGroup;
  public changesInValueIntangibleAssetsFg = {} as FormGroup;
  public changesInValuePropertyPlantEquipmentFg = {} as FormGroup;
  public impairmentIntangibleAssetsRecordedInIncomeStatementFg = {} as FormGroup;
  public impairmentIntangibleAssetsReversalRecordedInIncomeStatementFg = {} as FormGroup;
  public impairmentPropertyPlantEquipmentRecordedInIncomeStatementFg = {} as FormGroup;
  public impairmentPropertyPlantEquipmentReversalRecordedInIncomeStatementFg = {} as FormGroup;

  public impairmentIntangibleAssetsDisclosureFg = {} as FormGroup;
  public impairmentPropertyPlantEquipmentDisclosureFg = {} as FormGroup;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  public showDialog(input: number) {
    this.index = input
    this.dialogVisible = true;
  }

  constructor(
    public algDataService: BokkzAlgDataService,
    private cdRef: ChangeDetectorRef,
    private jrLogicService: BokkzJrLogic,
    public jrDataService: BokkzJrDataService) {
    this.createFormGroups();
  }

  ngOnInit(): void {
    if (this.selectedTabObservable) {
      this.selectedTabObservable
        .pipe(takeUntil(this.destroy$))
        .subscribe(tab => {
          this.selectedTabSubject.next(tab);
        });
    }

    combineLatest([
      this.selectedTabSubject.pipe(distinctUntilChanged()),
      this.jrDataService.jaarrapportageEntity
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([tab, jrEntity]) => {
        this.selectedTab = tab;
        this.jrEntity = jrEntity;
        this.patchData(jrEntity);
      });

    this.jrDataService.isRechtspersoon.subscribe((value) => {
      this.isRechtspersoon = value;
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedTabObservable']) {
      this.selectedTabObservable = changes['selectedTabObservable'].currentValue;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }


  public createFormGroups() {
    this.changesInValueIntangibleAssetsPropertyPlantEquipmentFg = this.jrDataService.createFormGroupMonetaryNoDecimalsPeriodValues();
    this.changesInValueIntangibleAssetsFg = this.jrDataService.createFormGroupMonetaryNoDecimalsPeriodValues();
    this.changesInValuePropertyPlantEquipmentFg = this.jrDataService.createFormGroupMonetaryNoDecimalsPeriodValues();
    this.impairmentIntangibleAssetsRecordedInIncomeStatementFg = this.jrDataService.createFormGroupBalanceItem();
    this.impairmentIntangibleAssetsReversalRecordedInIncomeStatementFg = this.jrDataService.createFormGroupBalanceItem();
    this.impairmentPropertyPlantEquipmentRecordedInIncomeStatementFg = this.jrDataService.createFormGroupBalanceItem();
    this.impairmentPropertyPlantEquipmentReversalRecordedInIncomeStatementFg = this.jrDataService.createFormGroupBalanceItem();

    this.impairmentIntangibleAssetsDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.impairmentPropertyPlantEquipmentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
  }

  private patchData(value: JaarrapportageEntity) {
    const overigeWaardeveranderingenIvaMva = value.rapportage?.jaarrekeningen?.at(0)?.winstEnVerliesrekening?.overigeWaardeveranderingenIvaMva;
    if (overigeWaardeveranderingenIvaMva) {
      this.changesInValueIntangibleAssetsPropertyPlantEquipmentFg.reset()
      this.changesInValueIntangibleAssetsFg.reset()
      this.changesInValuePropertyPlantEquipmentFg.reset()

      if (overigeWaardeveranderingenIvaMva.changesInValueIntangibleAssetsPropertyPlantEquipment) {
        this.changesInValueIntangibleAssetsPropertyPlantEquipmentFg.patchValue(overigeWaardeveranderingenIvaMva.changesInValueIntangibleAssetsPropertyPlantEquipment, {emitEvent: false})
      }

      const uitsplitsing = overigeWaardeveranderingenIvaMva.overigeWaardeveranderingenIvaMvaUitsplitsing;
      const tekstueel = overigeWaardeveranderingenIvaMva.overigeWaardeveranderingenIvaMvaTekstueel;

      if (uitsplitsing) {
        if (uitsplitsing.impairmentIntangibleAssetsRecordedInIncomeStatement) {
          const subItem = uitsplitsing.impairmentIntangibleAssetsRecordedInIncomeStatement;
          this.impairmentIntangibleAssetsRecordedInIncomeStatementFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.impairmentIntangibleAssetsRecordedInIncomeStatementFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.impairmentIntangibleAssetsReversalRecordedInIncomeStatement) {
          const subItem = uitsplitsing.impairmentIntangibleAssetsReversalRecordedInIncomeStatement;
          this.impairmentIntangibleAssetsReversalRecordedInIncomeStatementFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.impairmentIntangibleAssetsReversalRecordedInIncomeStatementFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.changesInValueIntangibleAssets) {
          const subItem = uitsplitsing.changesInValueIntangibleAssets;
          this.changesInValueIntangibleAssetsFg.patchValue(subItem, {emitEvent: false})
        }
        if (uitsplitsing.impairmentPropertyPlantEquipmentRecordedInIncomeStatement) {
          const subItem = uitsplitsing.impairmentPropertyPlantEquipmentRecordedInIncomeStatement;
          this.impairmentPropertyPlantEquipmentRecordedInIncomeStatementFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.impairmentPropertyPlantEquipmentRecordedInIncomeStatementFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.impairmentPropertyPlantEquipmentReversalRecordedInIncomeStatement) {
          const subItem = uitsplitsing.impairmentPropertyPlantEquipmentReversalRecordedInIncomeStatement;
          this.impairmentPropertyPlantEquipmentReversalRecordedInIncomeStatementFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.impairmentPropertyPlantEquipmentReversalRecordedInIncomeStatementFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.changesInValuePropertyPlantEquipment) {
          const subItem = uitsplitsing.changesInValuePropertyPlantEquipment;
          this.changesInValuePropertyPlantEquipmentFg.patchValue(subItem, {emitEvent: false})
        }
      }
      if (tekstueel) {
        if (tekstueel.impairmentIntangibleAssetsDisclosure) {
          this.impairmentIntangibleAssetsDisclosureFg.patchValue(tekstueel.impairmentIntangibleAssetsDisclosure);
        }
        if (tekstueel.impairmentPropertyPlantEquipmentDisclosure) {
          this.impairmentPropertyPlantEquipmentDisclosureFg.patchValue(tekstueel.impairmentPropertyPlantEquipmentDisclosure);
        }
      }
    }
  }

  updateTrialBalanceItems(lijst?: TrialBalanceItem[], formArray?: FormArray) {
    if (lijst && formArray) {
      for (let i = 0; i < lijst.length; i++) {
        if (i < formArray.length) {
          const control = formArray.at(i) as FormGroup;
          control.patchValue(lijst[i], {emitEvent: false});
        } else {
          const formGroup = this.jrDataService.createFormGroupTrialBalanceItem(lijst[i])
          formArray.push(formGroup, {emitEvent: false});
        }
      }
    }
  }

  public saveForm(): void {
    this.showCustomControls = false;
    this.cdRef.detectChanges();
    setTimeout(() => {
      this.showCustomControls = true;
      this.cdRef.detectChanges();
    });
    this.changesInValueIntangibleAssetsPropertyPlantEquipmentFg.updateValueAndValidity({ emitEvent: false });
    this.changesInValueIntangibleAssetsFg.updateValueAndValidity({ emitEvent: false });
    this.changesInValuePropertyPlantEquipmentFg.updateValueAndValidity({ emitEvent: false });
    this.impairmentIntangibleAssetsRecordedInIncomeStatementFg.updateValueAndValidity({ emitEvent: false });
    this.impairmentIntangibleAssetsReversalRecordedInIncomeStatementFg.updateValueAndValidity({ emitEvent: false });
    this.impairmentPropertyPlantEquipmentRecordedInIncomeStatementFg.updateValueAndValidity({ emitEvent: false });
    this.impairmentPropertyPlantEquipmentReversalRecordedInIncomeStatementFg.updateValueAndValidity({ emitEvent: false });
    this.impairmentIntangibleAssetsDisclosureFg.updateValueAndValidity({ emitEvent: false });
    this.impairmentPropertyPlantEquipmentDisclosureFg.updateValueAndValidity({ emitEvent: false });

    if (this.jrEntity && this.jrEntity.rapportage && this.jrEntity.rapportage.jaarrekeningen) {
      this.jrEntity.rapportage.jaarrekeningen[0] = {
        ...this.jrEntity.rapportage.jaarrekeningen[0],
        winstEnVerliesrekening: {
          ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening,
          overigeWaardeveranderingenIvaMva: {
            ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening?.overigeWaardeveranderingenIvaMva,
            overigeWaardeveranderingenIvaMvaUitsplitsing: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening?.overigeWaardeveranderingenIvaMva?.overigeWaardeveranderingenIvaMvaUitsplitsing,
              impairmentIntangibleAssetsRecordedInIncomeStatement: this.impairmentIntangibleAssetsRecordedInIncomeStatementFg.value,
              impairmentIntangibleAssetsReversalRecordedInIncomeStatement: this.impairmentIntangibleAssetsReversalRecordedInIncomeStatementFg.value,
              impairmentPropertyPlantEquipmentRecordedInIncomeStatement: this.impairmentPropertyPlantEquipmentRecordedInIncomeStatementFg.value,
              impairmentPropertyPlantEquipmentReversalRecordedInIncomeStatement: this.impairmentPropertyPlantEquipmentReversalRecordedInIncomeStatementFg.value,
            },
            overigeWaardeveranderingenIvaMvaTekstueel: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening?.overigeWaardeveranderingenIvaMva?.overigeWaardeveranderingenIvaMvaTekstueel,
              impairmentIntangibleAssetsDisclosure: this.impairmentIntangibleAssetsDisclosureFg.value,
              impairmentPropertyPlantEquipmentDisclosure: this.impairmentPropertyPlantEquipmentDisclosureFg.value,
            }
          },
        }
      } as Jaarrekening
    }

    this.jrEntity = {
      ...this.jrEntity,
      rapportage: {
        ...this.jrEntity.rapportage,
        jaarrekeningen: [this.jrEntity.rapportage?.jaarrekeningen?.at(0)]
      }
    } as Jaarrapportage
    this.jrDataService.updateEntity(this.jrEntity);
    this.jrLogicService.getCalculation(this.jrEntity)
  }
}

